















































import { API_BILL_STATIS, API_EXPORT_TASK_SYNC } from "@/configs/Apis";
import { MSG_EXPORT_FILE_NOTFOUND } from "@/configs/Consts";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import { Fetcher as Ajax } from "@/utils/Request";
import { isEmpty, showError, showWarning } from "@/utils/Common";
@Component
export default class BillStatis extends Vue {
  startMonth = moment().format("YYYY-01");
  endMonth = moment().format("YYYY-MM");

  dataList = [];

  mounted() {
    this.search();
  }

  search() {
    if (!this.startMonth || !this.endMonth) {
      showWarning("请选择起止月份");
      return;
    }
    Ajax.queryData(
      `${API_BILL_STATIS}?startMonth=${this.startMonth}&endMonth=${this.endMonth}`,
      {},
      "GET"
    )
      .then((rs: any) => {
        this.dataList = rs || [];
      })
      .catch(() => {
        this.dataList = [];
      });
  }

  exportData() {
    if (!this.startMonth || !this.endMonth) {
      showWarning("请选择起止月份");
      return;
    }

    const params: any = {
      dataType: "BillStatis",
      dataFilter: JSON.stringify({
        startMonth: this.startMonth,
        endMonth: this.endMonth,
      }),
    };
    Ajax.queryData(API_EXPORT_TASK_SYNC, params)
      .then((task: any) => {
        const url = task.resultUrl || "";
        if (isEmpty(url)) {
          showWarning(MSG_EXPORT_FILE_NOTFOUND);
          return;
        }
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        if (a.parentNode) {
          a.parentNode.removeChild(a);
        }
      })
      .catch(({ message }) => showError(message));
  }
}
